(function (angular, undefined) {
    'use strict';

    angular
        .module('blocks.i18n.globalization', [
            'tmh.dynamicLocale'
        ]);
})(angular);